import { type RouteRecordRaw } from "vue-router";
import { type MjfRouteMeta, RouteNames } from "@shared/types/localTypes/router";
import {
  beforeEnterQuickUpgrade,
  canAccessSubscription,
  canReachDashboard,
  checkForMultiSubscription,
  checkFromCookie,
  disableBetaIfNeeded,
  setCurrentSubscription,
} from "@/router/guard/dashboard";

export default {
  path: "/",
  name: RouteNames.Root,
  redirect: { name: RouteNames.AllSubscriptions },
  component: () => import("@/views/layout/LayoutBase.vue"),
  beforeEnter: checkFromCookie,
  children: [
    {
      path: "subscriptions",
      component: () => import("@/views/layout/BasicRouterView.vue"),
      children: [
        {
          path: "",
          name: RouteNames.AllSubscriptions,
          component: () =>
            import("@/views/allSubscriptions/AllSubscriptions.vue"),
          beforeEnter: checkForMultiSubscription,
        },
        {
          path: ":subscriptionId(\\d+)",
          component: () =>
            import("@/views/layout/SingleSubscriptionRouterView.vue"),
          beforeEnter: [
            canAccessSubscription,
            setCurrentSubscription,
            disableBetaIfNeeded,
          ],
          redirect: { name: RouteNames.Dashboard },
          children: [
            {
              path: "dashboard",
              name: RouteNames.Dashboard,
              component: () => import("@/views/dashboard/Dashboard.vue"),
              beforeEnter: [canReachDashboard],
            },
            {
              path: "value-center",
              name: RouteNames.ImpactCenter,
              component: () => import("@/views/impact-center/ImpactCenter.vue"),
            },
            {
              path: "value-center/print",
              name: RouteNames.ImpactCenterPrint,
              component: () =>
                import("@/views/impact-center/print/ImpactCenterPrint.vue"),
              meta: {
                parentRoute: RouteNames.ImpactCenter,
                hideLayout: true,
              } as MjfRouteMeta,
            },
            {
              path: "usage-explorer",
              name: RouteNames.UsageExplorer,
              component: () =>
                import("@/views/usage-explorer/UsageExplorer.vue"),
            },
            {
              path: "billing",
              name: RouteNames.Billing,
              component: () => import("@/views/billing/Billing.vue"),
            },
            {
              path: "topology",
              name: RouteNames.Topology,
              component: () => import("@/views/topology/Topology.vue"),
            },
            {
              path: "security",
              name: RouteNames.Security,
              component: () => import("@/views/security/Security.vue"),
            },
            {
              path: "users",
              name: RouteNames.Users,
              component: () => import("@/views/users/ManageUsers.vue"),
            },
            {
              path: "contacts",
              name: RouteNames.SupportContacts,
              component: () =>
                import("@/views/manageSupportContacts/ManageSupportContacts.vue"),
            },
            {
              path: "settings",
              name: RouteNames.Settings,
              component: () => import("@/views/settings/SettingsWrapper.vue"),
            },
            {
              path: "notification-center",
              name: RouteNames.NotificationCenter,
              component: () =>
                import("@/views/notification-center/NotificationCenterWrapper.vue"),
            },
            {
              path: "audit-logs",
              name: RouteNames.ActivityLog,
              component: () => import("@/views/activity-log/ActivityLog.vue"),
            },
            {
              path: "jpds",
              name: RouteNames.JPDs,
              component: () => import("@/views/jpds/JPD.vue"),
            },
            {
              path: "licenses",
              name: RouteNames.Licenses,
              component: () => import("@/views/licenses/Licenses.vue"),
            },
            {
              path: "authenticated-release",
              name: RouteNames.AuthenticatedRelease,
              component: () =>
                import("@/views/authenticatedRelease/AuthenticatedRelease.vue"),
            },
            {
              path: "tickets",
              name: RouteNames.SupportTickets,
              component: () =>
                import("@/views/supportTickets/SupportTicketsView.vue"),
            },
            {
              path: "threat-intelligence",
              name: RouteNames.ThreatIntelligence,
              component: () =>
                import("@/views/threatIntelligence/threatIntelligence.vue"),
            },
            {
              path: "upgrade",
              name: RouteNames.QuickUpgrade,
              meta: { isLandingView: true } as MjfRouteMeta,
              beforeEnter: beforeEnterQuickUpgrade,
              component: () => import("@/views/quick-upgrade/QuickUpgrade.vue"),
            },
            {
              path: "sandbox",
              name: RouteNames.Sandbox,
              component: () => import("@/views/sandbox/SandBox.vue"),
            },
          ],
        },
      ],
    },
  ],
} as RouteRecordRaw;
